<section class="banner" [ngClass]="{ 'bottom': is_edit }">
    <app-profilebanner></app-profilebanner>
    <div class="profile-header-menu wpee-container">
        <div class="profile-menu-wrapper d-flex space-bet">
            <div class="ham-icon" [ngClass]="{'is-triggred': is_show_menu_tab}"
                (click)="is_show_menu_tab=!is_show_menu_tab"><span></span></div>
            <ul class="profile-menu-tab" [ngClass]="{'is-open': is_show_menu_tab}">

                <li class="profile-menu-tab-list" [ngClass]="{ 'active': activeTab === 'Activity' }">
                    <a (click)="tabChange('Activity')">Activity</a>
                </li>
                <li class="profile-menu-tab-list" [ngClass]="{ 'active': activeTab === 'Profile' }">
                    <a (click)="tabChange('Profile')">Profile</a>
                </li>
                <li class="profile-menu-tab-list" [ngClass]="{ 'active': activeTab === 'Media' }">
                    <a (click)="tabChange('Media')">Media</a>
                </li>
                <li class="profile-menu-tab-list" [ngClass]="{ 'active': activeTab === 'Message' }">
                    <a (click)="tabChange('Message')">Message</a>
                </li>
                <li class="profile-menu-tab-list" [ngClass]="{ 'active': activeTab === 'Search' }">
                    <a (click)="tabChange('Search'); open_tab()">Search</a>
                </li>
                <li class="profile-menu-tab-list" [ngClass]="{ 'active': activeTab === 'Friends' }">
                    <a (click)="tabChange('Friends')">Friends</a>
                </li>
            </ul>
            <app-profile-icons></app-profile-icons>
        </div>
    </div>
</section>

<section class="tabs">
    <div class="wpee-container d-flex">
        <div class="activity_tab tab" *ngIf="activeTab == 'Activity'">
            <app-activity-tab></app-activity-tab>
        </div>
        <div class="profile_tab tab" *ngIf="activeTab == 'Profile'">
            <app-profile-tab></app-profile-tab>
        </div>
        <div class="media_tab tab" *ngIf="activeTab == 'Media'">
            <app-view-photos></app-view-photos>
        </div>
        <div class="friends_tab tab" *ngIf="activeTab == 'Friends'">
            <app-friends-tab></app-friends-tab>
        </div>
        <div class="friends_tab tab" *ngIf="activeTab == 'Search'">
            <app-search-tab></app-search-tab>
        </div>
        <div class="message_tab tab" *ngIf="activeTab == 'Message'">
            <app-message-tab></app-message-tab>
        </div>
        <div class="conditional_componant edit-profile" *ngIf="activeTab == 'edit_form'">
            <app-edit-profile></app-edit-profile>
        </div>
        <div class="conditional_componant edit-profile" *ngIf="activeTab == 'viewed'">
            <app-viewed-histry></app-viewed-histry>
        </div>

        <div class="conditional_componant edit-profile" *ngIf="activeTab == 'settings'">
            <app-settings></app-settings>
        </div>
        <div class="sug_user">
            <app-suggestion-user></app-suggestion-user>
            <app-online-member></app-online-member>
        </div>
        <!-- <router-outlet></router-outlet> -->
    </div>
</section>

<app-search-drawer></app-search-drawer>
<!-- <section class="edit_form edit_components" *ngIf="is_edit=='edit_form' || is_edit=='view_friends'">
    <div class="container conditional_componant_flex">
        <div class="conditional_componant edit-profile" *ngIf="is_edit=='edit_form'">
            <app-edit-profile></app-edit-profile>
        </div>

        <div class="conditional_componant view-photos" *ngIf="is_edit=='view_friends'">
            <app-friends-tab></app-friends-tab>
        </div>

        <div class="sug_user">
            <app-suggestion-user></app-suggestion-user>
            <app-online-member></app-online-member>
        </div>
    </div> -->
<!-- </section> -->